export const SEVERITY_LEVEL = {
  0: "critical",
  1: "critical",
  2: "critical",
  3: "critical",
  4: "warning",
  5: "warning",
  6: "info",
  7: "info",
}

export const EVENTS_LOG_EVENTS_TYPE = {
  SYSTEM_AUDIT: "System Audit",
  DEVICE_ONLINE: "Device Online",
  DEVICE_OFFLINE: "Device Offline",
  REGISTRATION_EVENT: "Device Registration",
  REBOOT_START: "Reboot",
  REBOOT_PROGRESS: "Reboot",
  REBOOT_COMPLETE: "Reboot",
  SCHEDULED_REBOOT_FIRED: "Reboot",
  REBOOT_COMMAND_ISSUED: "Reboot",
  SCHEDULED_REBOOT_SUCCEEDED: "Reboot",
  SCHEDULED_REBOOT_FAILED_OFFLINE: "Reboot",
  UNEXPECTED_REBOOT_DETECTED: "Unexpected reboot",
  MGMT_LINK_REESTABLISHED: "Management link re-established",
  FW_UPGRADE_PROGRESS: "Firmware upgrade started",
  FW_UPGRADE_SUCCEEDED: "Firmware upgraded",
  FW_UPGRADE_FAILED: "Firmware upgrade failed",
  CL_EVENT_CLIENT_REJECTED: "Client association rejected",
  CL_EVENT_CLIENT_AUTH_PASS: "Client Authentication Succeeded",
  CL_EVENT_CLIENT_AUTH_FAIL: "Client Authentication Failed",
  CL_EVENT_CLIENT_JOIN: "Client Association",
  CL_EVENT_CLIENT_IPADDR_CHANGE: "Client IP change",
  CL_EVENT_CLIENT_LEAVE: "Client Disassociation",
  CL_EVENT_CLIENT_EXCEEDED_LIMIT: "Client quota limit exceeded",
  CL_EVENT_IPADDR_CHANGE: "IP Address Change",
  CL_EVENT_CHANNEL_CHANGE: "Channel Change",
  CL_EVENT_UPLINK_PORT_CHANGE: "Uplink port change",
  CL_EVENT_SW_PORT_LINKUP: "Port Status",
  CL_EVENT_SW_PORT_LINKDOWN: "Port Status",
  CL_EVENT_SW_PORT: "Port Status",
  CL_EVENT_SW_PORT_ERROR: "Port Error",
  CL_EVENT_SW_PORT_ERROR_RECOVER: "Port Error Recovery",
  CL_EVENT_SW_FAN: "Fan",
  CL_EVENT_SW_POE_PORT: "PoE status",
  CL_EVENT_SW_POE: "PoE status",
  PROXY_SSH_AUTH_FAILED: "SSH Connection",
  PROXY_SSH_TIMEOUT: "SSH Connection",
  PROXY_SSH_REJECT: "SSH Connection",
  PROXY_SSH_FAILED: "SSH Connection",
  UNEXPECTED_REBOOT_DETECTED: "Unexpected reboot"
}

export const EVENTS_LOG_ERROR_TYPE = {
  0: "PoE System Overload Denied",
  1: "PoE denied",
  2: "LACP abnormal",
  3: "Authentication failed",
  4: "STP discarding",
  5: "Port loop",
  7: "Port disabled manually",
}

// Canonical additions from the Nuclias Unity Event Types workbook.  Keep
// audit and device events in this shared catalog so every Events scope uses
// identical Description rendering.
const ADDITIONAL_EVENTS_LOG = {
  access_org: "<AccountNameWithUniqueLink> accessed organization <Organization>.",
  access_site: "<AccountNameWithUniqueLink> accessed site <Site>.",
  device_fw_upgrade_task_start: "The upgrade task started for model series <ModelName>, upgrading from version <OldVersion> to <NewVersion>.",
  device_fw_upgrade_task_complete: "The upgrade task completed for model series <ModelName>, upgraded from version <OldVersion> to <NewVersion>.",
  wireless_captive_portal_changed: "Captive Portal settings of Wireless network <WirelessNetworkName> were changed by account <AccountNameWithUniqueLink>.",
  site_cloned: "Site <NewSite> was cloned from site <OldSite> by <AccountNameWithUniqueLink>.",
  support_token_generated: "A support token (<AccessLevel>, expires <ExpiryDate>) was generated by <AccountNameWithUniqueLink>.",
  support_access_started: "Support access started by <SupportEmployeeID>.",
  support_token_extended: "Support token extended to <NewExpiryDate> by <AccountNameWithUniqueLink>.",
  support_session_transferred: "Support session transferred to <SupportEmployeeID>.",
  support_token_revoked: "Support token revoked by <AccountNameWithUniqueLink>.",
  support_token_resolved: "Support token resolved by <SupportEmployeeID>.",
  support_token_expired: "Support token expired.",
  firmware_cloud_sync_failed: "Cloud sync of the firmware repository failed. Reason: <ErrorMessage>.",
  scheduled_reboot_rule_created: "Scheduled reboot rule <RuleName> was created by account <AccountNameWithUniqueLink>.",
  scheduled_reboot_rule_changed: "Scheduled reboot rule <RuleName> was changed by account <AccountNameWithUniqueLink>.",
  scheduled_reboot_rule_deleted: "Scheduled reboot rule <RuleName> was deleted by account <AccountNameWithUniqueLink>.",
  user_privilege_overwritten_by_higher_tier: "Privilege of <ChangedAccountNameWithUniqueLink> for scope <Scope> was overwritten when account <AccountNameWithUniqueLink> granted the same scope from a higher tier.",
  captive_portal_payment_succeeded: "Paid access payment for captive portal <PortalName> succeeded (client <ClientNameWithMACAsLink>).",
  captive_portal_payment_failed: "Paid access payment for captive portal <PortalName> failed (client <ClientNameWithMACAsLink>). Reason: <ErrorMessage>.",
  remote_support_token_generated: "A Remote Support token (<AccessLevel>, expires <ExpiryDate>) was generated by <AccountNameWithUniqueLink>.",
  remote_support_access_started: "Remote Support access started by <SupportEmployeeID>.",
  remote_support_token_extended: "Remote Support token extended to <NewExpiryDate> by <AccountNameWithUniqueLink>.",
  remote_support_session_transferred: "Remote Support session transferred to <SupportEmployeeID>.",
  remote_support_token_revoked: "Remote Support token revoked by <AccountNameWithUniqueLink>.",
  remote_support_token_resolved: "Remote Support token resolved by <SupportEmployeeID>.",
  remote_support_token_expired: "Remote Support token expired.",
  msp_org_added: "<AccountNameWithUniqueLink> added organization <Organization> to MSP <MSPName>.",
  msp_org_detached: "<AccountNameWithUniqueLink> removed organization <Organization> from MSP <MSPName>.",
  msp_credit_disbursed: "<AccountNameWithUniqueLink> disbursed <CreditAmount> Credits from the <MSPName> treasury to <Organization>.",
  msp_report_exported: "<AccountNameWithUniqueLink> exported the <Period> billing report for <Organization> under MSP <MSPName>.",
  msp_user_access_granted_msp: "<AccountNameWithUniqueLink> granted <ChangedAccountName> the <Role> role on MSP <MSPName>.",
  msp_user_access_granted_org: "<AccountNameWithUniqueLink> granted <ChangedAccountName> the <Role> role on <Organization> under MSP <MSPName>.",
  msp_org_alarms_muted: "<AccountNameWithUniqueLink> muted alarms for <Organization> under MSP <MSPName>.",
  msp_enabled: "<AccountNameWithUniqueLink> set up MSP <MSPName> to centrally manage their organizations.",
  site_summary_report_generated: "The weekly summary report for <Site> (<Period>) has been generated and is ready to view.",
  msp_credit_withdrawn: "<AccountNameWithUniqueLink> withdrew <CreditAmount> Credits from <Organization> back to the <MSPName> treasury.",
  msp_treasury_auto_draw: "<CreditAmount> Credits were auto-drawn from the <MSPName> treasury to cover <Organization>'s subscription.",
  msp_org_autodraw_updated: "<AccountNameWithUniqueLink> turned <NewState> treasury auto-draw for <Organization> under MSP <MSPName>.",
  wlan_optimization_changed: "WLAN Optimization settings were changed by account <AccountNameWithUniqueLink>.",
  eligible_channels_changed: "Eligible channels for the <RadioBand> radio were changed by account <AccountNameWithUniqueLink>.",
  compensatory_key_issued: "A compensatory licence key worth <CreditAmount> Credits was issued for <Organization> and sent to <AccountNameWithUniqueLink>.",
  ap_remove: "Access point <DeviceNameWithMACAsLink> is removed.",
  ap_reboot_start: "Requesting access point <DeviceNameWithMACAsLink> to reboot. Reason: {reasonDescription}.",
  ap_reboot_progress: "Access point <DeviceNameWithMACAsLink> is now rebooting.",
  ap_reboot_complete: "Access point <DeviceNameWithMACAsLink> has rebooted and now online. Reason: {reasonDescription}.",
  ap_client_reject: "Client <ClientNameWithMACAsLink> association rejected at <DeviceNameWithMACAsLink>.; Manufacturer: {Client Manufacturer name}; Auth: {reasonCode}",
  ap_client_limit: "Client <ClientNameWithMACAsLink> quota limit exceeded at <DeviceNameWithMACAsLink>.; Manufacturer: {Client Manufacturer name}; Auth: {reasonCode}",
  sw_remove: "Swich <DeviceNameWithMACAsLink> is removed.",
  sw_reboot_start: "Requesting swich <DeviceNameWithMACAsLink> to reboot. Reason: {reasonCode}; {reasonDescription}",
  sw_reboot_progress: "Swich <DeviceNameWithMACAsLink> is now rebooting.",
  sw_reboot_complete: "Swich <DeviceNameWithMACAsLink> has rebooted and now online. Reason: {reasonCode}; {reasonDescription}",
  sw_uplink_port_changed: "The uplink port on switch <DeviceNameWithMACAsLink> changed from <OldUplinkPort> to <NewUplinkPort>.",
  sw_fan_error: "Fan on switch <DeviceNameWithMACAsLink> failed to work properly.",
  sw_poe_error_1: "A power short circuit was detected on PoE port <PortNum> on switch <DeviceNameWithMACAsLink>.",
  sw_poe_error_2: "A power overload was detected on PoE port <PortNum> on switch <DeviceNameWithMACAsLink>.",
  sw_poe_error_3: "Power output was denied on PoE port <PortNum> on switch <DeviceNameWithMACAsLink>.",
  sw_poe_error_4: "A thermal shutdown occurred on PoE port <PortNum> on switch <DeviceNameWithMACAsLink>.",
  sw_poe_error_5: "Power turned on for PoE port <PortNum> on switch <DeviceNameWithMACAsLink>.",
  sw_poe_error_6: "Power turned off for PoE port <PortNum> on switch <DeviceNameWithMACAsLink>.",
  sw_poe_error: "The system exceeded the maximum power budget on switch <DeviceNameWithMACAsLink>.",
  sw_topo_changed: "STP topology changed on port <PortNum> on switch <DeviceNameWithMACAsLink>.",
  sw_stp_root_changed: "STP selected a new root bridge with MAC <MAC> and priority <Priority> on switch <DeviceNameWithMACAsLink>.",
  sw_voice_vlan_1: "Port <PortNum> on switch <DeviceNameWithMACAsLink> was added to Voice VLAN <VlanID>.",
  sw_voice_vlan_2: "Port <PortNum> on switch <DeviceNameWithMACAsLink> was removed from Voice VLAN <VlanID>.",
  sw_port_lacp_1: "Port <PortNum> on switch <DeviceNameWithMACAsLink> was attached to port channel <GroupId>.",
  sw_port_lacp_2: "Port <PortNum> on switch <DeviceNameWithMACAsLink> was detached from port channel <GroupId>.",
  sw_8021x_1: "802.1X authentication failed for user <Username> on port <PortNum> (MAC <MAC>) on switch <DeviceNameWithMACAsLink>.",
  sw_8021x_2: "802.1X authentication succeeded for user <Username> on port <PortNum> (MAC <MAC>) on switch <DeviceNameWithMACAsLink>.",
  sw_guest_vlan_1: "Port <PortNum> on switch <DeviceNameWithMACAsLink> was added to Guest VLAN <VlanID>.",
  sw_guest_vlan_2: "Port <PortNum> on switch <DeviceNameWithMACAsLink> was removed from Guest VLAN <VlanID>.",
  sw_dhcpscrn: "An unauthorized DHCP server IP address was detected on port <PortNum> on switch <DeviceNameWithMACAsLink>.",
  proxy_ssh_auth_fail: "Proxy <ProxyNameWithMACAsLink> authentication with device <DeviceNameWithMACAsLink> at IP <IP of connection destination> has failed using.",
  scheduled_reboot_fired: "Device <DeviceNameWithMACAsLink> rebooted as scheduled by rule <RuleName>.",
  reboot_command_issued: "Controller issued a reboot command to <DeviceNameWithMACAsLink>. Source: <RebootSource>.",
  scheduled_reboot_succeeded: "Device <DeviceNameWithMACAsLink> rebooted successfully.",
  scheduled_reboot_failed_offline: "Device <DeviceNameWithMACAsLink> did not reboot for scheduled rule <RuleName>: it stayed offline for the entire 24-hour retry window.",
  ap_radio_power_changed: "Access point <DeviceNameWithMACAsLink>'s <RadioBand> transmit power changed from <OldTxPower> to <NewTxPower>.",
  unexpected_router_reboot_detected: "Router <DeviceNameWithMACAsLink> rebooted unexpectedly — no firmware upgrade or administrative reboot was requested.",
  ap_mgmt_link_reestablished: "Access point <DeviceNameWithMACAsLink> re-established its management link to the Nuclias Unity cloud after an unstable disconnect.",
  sw_mgmt_link_reestablished: "Switch <DeviceNameWithMACAsLink> re-established its management link to the Nuclias Unity cloud after an unstable disconnect.",
  router_mgmt_link_reestablished: "Router <DeviceNameWithMACAsLink> re-established its management link to the Nuclias Unity cloud after an unstable disconnect.",
};

export const EVENTS_LOG = {
  // System Audit
  device_synced: "The device <DeviceNameWithMACAsLink> had its configuration synced successfully.",
  device_sync_failed: "The device <DeviceNameWithMACAsLink> failed to sync configuration.",
  unexpected_ap_reboot_detected: "Access point <DeviceNameWithMACAsLink> rebooted unexpectedly — no firmware upgrade or administrative reboot was requested.",
  unexpected_sw_reboot_detected: "Switch <DeviceNameWithMACAsLink> rebooted unexpectedly — no firmware upgrade or administrative reboot was requested.",
  device_fw_upgrade_schedule_create: "The upgrade schedule for model series <ModelName> was created, setting the upgrade window to <NewUpgradeWindow>.",
  device_fw_upgrade_schedule_cancel: "The upgrade schedule for model series <ModelName> was canceled.",
  device_fw_upgrade_schedule_change: "The upgrade schedule for model series <ModelName> was changed from version <OldVersion> to <NewVersion> with policy <NewUpgradeWindow>.",
  invite_user_org: "User <ChangedAccountNameWithUniqueLink> was invited to organization <Org> by account <AccountNameWithUniqueLink>.",
  invite_user_site: "User <ChangedAccountNameWithUniqueLink> was invited to site <Site> in organization <Org> by account <AccountNameWithUniqueLink>.",
  remove_user_org: "User <ChangedAccountName> was removed organization <Org> by account <AccountNameWithUniqueLink>.",
  remove_user_site: "User <ChangedAccountName> was removed from site <Site> in organization <Org> by account <AccountNameWithUniqueLink>.",
  user_leave_org: "User <ChangedAccountName> left site <Site> in organization <Org>.",
  user_leave_site: "User <ChangedAccountName> left organization <Org>.",
  change_user_privilege: "User <ChangedAccountNameWithUniqueLink>'s privilege changed by account <AccountNameWithUniqueLink>.",
  captive_portal_created: "Captive portal configuration <PortalName> was created by account <AccountNameWithUniqueLink>.",
  captive_portal_changed: "Captive portal configuration <PortalName> was changed by account <AccountNameWithUniqueLink>.",
  captive_portal_delete: "Captive portal configuration <PortalName> was deleted by account <AccountNameWithUniqueLink>.",
  ip_address_profile_created: "IP address profile <IPAddressProfileName> were created by account <AccountNameWithUniqueLink>.",
  ip_address_profile_deleted: "IP address profile <IPAddressProfileName> were deleted by account <AccountNameWithUniqueLink>.",
  ip_address_profile_changed: "IP address profile <IPAddressProfileName> were changed by account <AccountNameWithUniqueLink>.",
  schedule_profile_created: "Schedule profile <ScheduleProfileName> were created by account <AccountNameWithUniqueLink>.",
  schedule_profile_deleted: "Schedule profile <ScheduleProfileName> were deleted by account <AccountNameWithUniqueLink>.",
  schedule_profile_changed: "Schedule profile <ScheduleProfileName> were changed by account <AccountNameWithUniqueLink>.",
  ldap_server_created: "LDAP Server <LdapServerName> was created by account <AccountNameWithUniqueLink>.",
  ldap_server_changed: "LDAP Server <LdapServerName> was changed by account <AccountNameWithUniqueLink>.",
  ldap_server_deleted: "LDAP Server <LdapServerName> was deleted by account <AccountNameWithUniqueLink>.",
  user_account_created: "User Account <UserAccountName> was created by account <AccountNameWithUniqueLink>.",
  user_account_changed: "User Account <UserAccountName> was changed by account <AccountNameWithUniqueLink>.",
  user_account_deleted: "User Account <UserAccountName> was deleted by account <AccountNameWithUniqueLink>.",
  device_account_changed: "Device Account was changed by account <AccountNameWithUniqueLink>.",
  device_adopt: "Device <DeviceNameWithMACAsLink> is being adopt by account <AccountNameWithUniqueLink>.",
  device_removed: "Device <DeviceName> was removed by account <AccountNameWithUniqueLink>.",
  device_moved: "Device <DeviceNameWithMACAsLink> was migrated from site <OldSite> to site <NewSite> by account <AccountNameWithUniqueLink>.",
  wireless_created: "Wireless network <WirelessNetworkName> were created by account <AccountNameWithUniqueLink>.",
  wireless_deleted: "Wireless network <WirelessNetworkName> were deleted by account <AccountNameWithUniqueLink>.",
  wireless_changed: "Wireless network <WirelessNetworkName> were changed by account <AccountNameWithUniqueLink>.",
  device_radio_changed: "Radio settings for device <DeviceNameWithMACAsLink> changed  by account <AccountNameWithUniqueLink>.",
  device_network_changed: "Management interface for device <DeviceNameWithMACAsLink> changed  by account <AccountNameWithUniqueLink>.",
  org_time_zone_changed: "Time zone settings for organization were updated by account <AccountNameWithUniqueLink>.",
  site_time_zone_changed: "Time zone settings for site <Site> were updated by account <AccountNameWithUniqueLink>.",
  wireless_radio_changed: "Wireless Radio Settings for site <Site> were updated by account <AccountNameWithUniqueLink>.",
  wired_basic_changed: "Wired Basic Settings for site <Site> were updated by account <AccountNameWithUniqueLink>.",
  wired_voice_vlan_changed: "Wired Voice Vlan Settings for site <Site> were updated by account <AccountNameWithUniqueLink>.",
  wired_qos_changed: "Wired Quality of Service Settings for site <Site> were updated by account <AccountNameWithUniqueLink>.",
  wired_ipv4_acl_changed: "Wired IPv4 ACL Settings for site <Site> were updated by account <AccountNameWithUniqueLink>.",
  device_info_changed: "Device information for <DeviceNameWithMACAsLink> changed from <OldDeviceInfo>\n\nto <NewDeviceInfo>\n\nby account <AccountNameWithUniqueLink>.",
  wired_port_changed: "Wired port settings on device <DeviceNameWithMACAsLink> changed from <OldWiredSettings>\n\nto <NewWiredSettings>\n\nby account <AccountNameWithUniqueLink>.",
  port_profile_changed: "Port profile changed from <OldPortProfile>\n\nto <NewPortProfile>\n\nby account <AccountNameWithUniqueLink>.",
  duplicated_device_connection: "The device <RejectDeviceId> with <DeviceNameWithMACAsLink> coming from IP <RejectDeviceIp> registering, is now conflicting with <OldDeviceId> coming from IP <OldDeviceIp>.  Former is rejected.",
  // ap
  // device 上線, 由 sentry 通知
  ap_online: "Access point <DeviceNameWithMACAsLink> is now online.",
  // device 斷線, 由 sentry 通知
  ap_offline: "Access point <DeviceNameWithMACAsLink> is now offline.",
  // device 完成註冊, 由 sentry 通知
  ap_adopt: "Access point <DeviceNameWithMACAsLink> is now adopt.",
  // Device 開始執行 fw upgrade(下載fw, 寫進flash...)
  ap_firmware_progress: "Access point <DeviceNameWithMACAsLink> upgrading.",
  // Device 完成 fw upgrade 
  ap_firmware_success: "Access point <DeviceNameWithMACAsLink> upgraded to <FWver>.",
  // Device fw upgrade 失敗
  ap_firmware_fail: "Access point <DeviceNameWithMACAsLink> upgrade failed.",
  // wifi client 成功連上 wifi 後, 通過 CP 驗證
  ap_client_auth_pass: "Client <ClientNameWithMACAsLink> authenticated at <DeviceNameWithMACAsLink> as user <Username>.; Manufacturer: {Client Manufacturer name}; Auth: {reasonCode}",
  // wifi client 成功連上 wifi 後, 要進行 CP 驗證的時候失敗
  ap_client_auth_fail: "Client <ClientNameWithMACAsLink> authentication failed at <DeviceNameWithMACAsLink> as user <Username>.; Manufacturer: {Client Manufacturer name}; Auth: {reasonCode}",
  //  wifi client 成功連上wifi
  ap_client_joined: "Client <ClientNameWithMACAsLink> associated to <DeviceNameWithMACAsLink> with IP <ClientIpAddress>.; Manufacturer: {Client Manufacturer name}; Auth: {reasonCode}",
  // wifi client ip 改變
  ap_client_ip_changed: "Client <ClientNameWithMACAsLink> IP changed to <ClientIpAddress>.; Manufacturer: {Client Manufacturer name}; ",
  // wifi client 離開 wifi
  ap_client_left: "Client <ClientNameWithMACAsLink> left <DeviceNameWithMACAsLink>.; Manufacturer: {Client Manufacturer name}; ",
  // device 的 ip 改變
  ap_ip_changed: "Access point <DeviceNameWithMACAsLink> IP changed to <DeviceIpAddress>.",
  // ap 的 channel 改變
  // 根據 Bug 33230 移除 Where 5G is "2.4G" or "5G" or "6G" 
  ap_radio_changed: `Access point <DeviceNameWithMACAsLink>'s <RadioBand> channel changed from <OldChannel> to <NewChannel>.`,
  // switch
  // device 上線, 由 sentry 通知
  sw_online: "Swich <DeviceNameWithMACAsLink> is now online.",
  // device 斷線, 由 sentry 通知
  sw_offline: "Swich <DeviceNameWithMACAsLink> is now offline.",
  // device 完成註冊, 由 sentry 通知
  sw_adopt: "Swich <DeviceNameWithMACAsLink> is now adopt.",
  // Device 開始執行 fw upgrade(下載fw, 寫進flash...)
  sw_firmware_progress: "Swich <DeviceNameWithMACAsLink> upgrading.",
  // Device 完成 fw upgrade 
  sw_firmware_success: "Swich <DeviceNameWithMACAsLink> upgraded to <FWver>.",
  // Device fw upgrade 失敗
  sw_firmware_fail: "Swich <DeviceNameWithMACAsLink> upgrade failed.",
  // device 的 ip 改變
  sw_ip_changed: "Switch <DeviceNameWithMACAsLink> IP changed to <DeviceIpAddress>.",
  // device port link up
  sw_port_linkup: "Port <PortNum> on switch <DeviceNameWithMACAsLink> link up.",
  // device port link down
  sw_port_linkdown: "Port <PortNum> on switch <DeviceNameWithMACAsLink> link down.",
  // device port error
  sw_port_error: "Port <PortNum> on switch <DeviceNameWithMACAsLink> reported an error. Error: <ErrorTypeString>",
  // device port error recover
  sw_port_error_recover: "Port <PortNum> on switch <DeviceNameWithMACAsLink> recovered from previous error. Error: <ErrorTypeString>",
  // device 上線, 由 sentry 通知
  proxy_online: "Proxy <DeviceNameWithMACAsLink> is now online.",
  // device 斷線, 由 sentry 通知
  proxy_offline: "Proxy <DeviceNameWithMACAsLink> is now offline.",
  // proxy ssh connections
  proxy_ssh_auth_failed: "Proxy <DeviceNameWithMACAsLink> authentication with device <PayloadDeviceNameWithMACAsLink> at IP <IP of connection destination> has failed using.",
  proxy_ssh_timeout: "Proxy <DeviceNameWithMACAsLink> connection with device <PayloadDeviceNameWithMACAsLink> at IP <IP of connection destination> has timeout.",
  proxy_ssh_reject: "Proxy <DeviceNameWithMACAsLink> connection with device <PayloadDeviceNameWithMACAsLink> at IP <IP of connection destination> has rejected.",
  proxy_ssh_failed: "Proxy <DeviceNameWithMACAsLink> connection with device <PayloadDeviceNameWithMACAsLink> at IP <IP of connection destination> has failed.",
  // device ssh connections
  device_ssh_auth_fail: "Proxy <ProxyName> authentication with device <DeviceNameWithMACAsLink> at IP <IP of connection destination> has failed using.",
  device_ssh_timeout: "Proxy <ProxyName> connection with device <DeviceNameWithMACAsLink> at IP <IP of connection destination> has timeout.",
  device_ssh_reject: "Proxy <ProxyName> connection with device <DeviceNameWithMACAsLink> at IP <IP of connection destination> has rejected.",
  device_ssh_failed: "Proxy <ProxyName> connection with device <DeviceNameWithMACAsLink> at IP <IP of connection destination> has failed.",
  // router
  // device 上線, 由 sentry 通知
  router_online: "Router <DeviceNameWithMACAsLink> is now online.",
  // device 斷線, 由 sentry 通知
  router_offline: "Router <DeviceNameWithMACAsLink> is now offline.",
  // device 完成註冊, 由 sentry 通知
  router_adopt: "Router <DeviceNameWithMACAsLink> is now adopt.",
  // Device 開始執行 fw upgrade(下載fw, 寫進flash...)
  router_firmware_progress: "Router <DeviceNameWithMACAsLink> upgrading.",
  // Device 完成 fw upgrade 
  router_firmware_success: "Router <DeviceNameWithMACAsLink> upgraded to <FWver>.",
  // Device fw upgrade 失敗
  router_firmware_fail: "Router <DeviceNameWithMACAsLink> upgrade failed.",
  ...ADDITIONAL_EVENTS_LOG,
};

const ACCOUNT_LINK = { AccountNameWithUniqueLink: "accountName" };
const DEVICE_LINK = { DeviceNameWithMACAsLink: "deviceName" };
const CLIENT_AND_DEVICE_LINK = {
  ClientNameWithMACAsLink: "payload.clientName",
  DeviceNameWithMACAsLink: "deviceName",
  "Client Manufacturer name": "payload.manufacturer",
  reasonCode: "payload.reasonCode",
};

const ADDITIONAL_EVENTS_LOG_MAP = {
  access_org: { ...ACCOUNT_LINK, Organization: "orgName" },
  access_site: { ...ACCOUNT_LINK, Site: "siteName" },
  device_fw_upgrade_task_start: { ModelName: "payload.modelName", OldVersion: "payload.oldVersion", NewVersion: "payload.newVersion" },
  device_fw_upgrade_task_complete: { ModelName: "payload.modelName", OldVersion: "payload.oldVersion", NewVersion: "payload.newVersion" },
  wireless_captive_portal_changed: { WirelessNetworkName: "payload.networkName", ...ACCOUNT_LINK },
  site_cloned: { NewSite: "payload.newSiteName", OldSite: "payload.oldSiteName", ...ACCOUNT_LINK },
  support_token_generated: { AccessLevel: "payload.accessLevel", ExpiryDate: "payload.expiryDate", ...ACCOUNT_LINK },
  support_access_started: { SupportEmployeeID: "payload.supportEmployeeId" },
  support_token_extended: { NewExpiryDate: "payload.newExpiryDate", ...ACCOUNT_LINK },
  support_session_transferred: { SupportEmployeeID: "payload.supportEmployeeId" },
  support_token_revoked: ACCOUNT_LINK,
  support_token_resolved: { SupportEmployeeID: "payload.supportEmployeeId" },
  support_token_expired: {},
  firmware_cloud_sync_failed: { ErrorMessage: "payload.errorMessage" },
  scheduled_reboot_rule_created: { RuleName: "payload.ruleName", ...ACCOUNT_LINK },
  scheduled_reboot_rule_changed: { RuleName: "payload.ruleName", ...ACCOUNT_LINK },
  scheduled_reboot_rule_deleted: { RuleName: "payload.ruleName", ...ACCOUNT_LINK },
  user_privilege_overwritten_by_higher_tier: { ChangedAccountNameWithUniqueLink: "payload.changedAccountName", Scope: "payload.scope", ...ACCOUNT_LINK },
  captive_portal_payment_succeeded: { PortalName: "payload.portalName", ClientNameWithMACAsLink: "payload.clientName" },
  captive_portal_payment_failed: { PortalName: "payload.portalName", ClientNameWithMACAsLink: "payload.clientName", ErrorMessage: "payload.errorMessage" },
  remote_support_token_generated: { AccessLevel: "payload.accessLevel", ExpiryDate: "payload.expiryDate", ...ACCOUNT_LINK },
  remote_support_access_started: { SupportEmployeeID: "payload.supportEmployeeId" },
  remote_support_token_extended: { NewExpiryDate: "payload.newExpiryDate", ...ACCOUNT_LINK },
  remote_support_session_transferred: { SupportEmployeeID: "payload.supportEmployeeId" },
  remote_support_token_revoked: ACCOUNT_LINK,
  remote_support_token_resolved: { SupportEmployeeID: "payload.supportEmployeeId" },
  remote_support_token_expired: {},
  msp_org_added: { ...ACCOUNT_LINK, Organization: "payload.orgName", MSPName: "belongToMspName" },
  msp_org_detached: { ...ACCOUNT_LINK, Organization: "payload.orgName", MSPName: "belongToMspName" },
  msp_credit_disbursed: { ...ACCOUNT_LINK, CreditAmount: "payload.creditAmount", MSPName: "belongToMspName", Organization: "payload.orgName" },
  msp_report_exported: { ...ACCOUNT_LINK, Period: "payload.period", Organization: "payload.orgName", MSPName: "mspName" },
  msp_user_access_granted_msp: { ...ACCOUNT_LINK, ChangedAccountName: "payload.changedAccountName", Role: "payload.role", MSPName: "mspName" },
  msp_user_access_granted_org: { ...ACCOUNT_LINK, ChangedAccountName: "payload.changedAccountName", Role: "payload.role", Organization: "payload.orgName", MSPName: "mspName" },
  msp_org_alarms_muted: { ...ACCOUNT_LINK, Organization: "orgName", MSPName: "mspName" },
  msp_enabled: { ...ACCOUNT_LINK, MSPName: "belongToMspName" },
  site_summary_report_generated: { Site: "siteName", Period: "payload.period" },
  msp_credit_withdrawn: { ...ACCOUNT_LINK, CreditAmount: "payload.creditAmount", Organization: "payload.orgName", MSPName: "belongToMspName" },
  msp_treasury_auto_draw: { CreditAmount: "payload.creditAmount", MSPName: "mspName", Organization: "orgName" },
  msp_org_autodraw_updated: { ...ACCOUNT_LINK, NewState: "payload.newState", Organization: "orgName", MSPName: "mspName" },
  wlan_optimization_changed: ACCOUNT_LINK,
  eligible_channels_changed: { RadioBand: "payload.band", ...ACCOUNT_LINK },
  compensatory_key_issued: { CreditAmount: "payload.creditAmount", Organization: "orgName", ...ACCOUNT_LINK },
  ap_remove: DEVICE_LINK,
  ap_reboot_start: { ...DEVICE_LINK, reasonDescription: "payload.reasonDescription" },
  ap_reboot_progress: DEVICE_LINK,
  ap_reboot_complete: { ...DEVICE_LINK, reasonDescription: "payload.reasonDescription" },
  ap_client_reject: CLIENT_AND_DEVICE_LINK,
  ap_client_limit: CLIENT_AND_DEVICE_LINK,
  sw_remove: DEVICE_LINK,
  sw_reboot_start: { ...DEVICE_LINK, reasonCode: "payload.reasonCode", reasonDescription: "payload.reasonDescription" },
  sw_reboot_progress: DEVICE_LINK,
  sw_reboot_complete: { ...DEVICE_LINK, reasonCode: "payload.reasonCode", reasonDescription: "payload.reasonDescription" },
  sw_uplink_port_changed: { ...DEVICE_LINK, OldUplinkPort: "payload.oldPortNum", NewUplinkPort: "payload.portNum" },
  sw_fan_error: DEVICE_LINK,
  sw_poe_error_1: { ...DEVICE_LINK, PortNum: "payload.portNum" },
  sw_poe_error_2: { ...DEVICE_LINK, PortNum: "payload.portNum" },
  sw_poe_error_3: { ...DEVICE_LINK, PortNum: "payload.portNum" },
  sw_poe_error_4: { ...DEVICE_LINK, PortNum: "payload.portNum" },
  sw_poe_error_5: { ...DEVICE_LINK, PortNum: "payload.portNum" },
  sw_poe_error_6: { ...DEVICE_LINK, PortNum: "payload.portNum" },
  sw_poe_error: DEVICE_LINK,
  sw_topo_changed: { ...DEVICE_LINK, PortNum: "payload.portNum" },
  sw_stp_root_changed: { ...DEVICE_LINK, MAC: "payload.macaddr", Priority: "payload.priority" },
  sw_voice_vlan_1: { ...DEVICE_LINK, PortNum: "payload.portNum", VlanID: "payload.vlanId" },
  sw_voice_vlan_2: { ...DEVICE_LINK, PortNum: "payload.portNum", VlanID: "payload.vlanId" },
  sw_port_lacp_1: { ...DEVICE_LINK, PortNum: "payload.portNum", GroupId: "payload.groupId" },
  sw_port_lacp_2: { ...DEVICE_LINK, PortNum: "payload.portNum", GroupId: "payload.groupId" },
  sw_8021x_1: { ...DEVICE_LINK, Username: "payload.username", PortNum: "payload.portNum", MAC: "payload.macaddr" },
  sw_8021x_2: { ...DEVICE_LINK, Username: "payload.username", PortNum: "payload.portNum", MAC: "payload.macaddr" },
  sw_guest_vlan_1: { ...DEVICE_LINK, PortNum: "payload.portNum", VlanID: "payload.vlanId" },
  sw_guest_vlan_2: { ...DEVICE_LINK, PortNum: "payload.portNum", VlanID: "payload.vlanId" },
  sw_dhcpscrn: { ...DEVICE_LINK, PortNum: "payload.portNum" },
  proxy_ssh_auth_fail: { ProxyNameWithMACAsLink: "payload.proxyName", ...DEVICE_LINK, "IP of connection destination": "payload.ip" },
  scheduled_reboot_fired: { ...DEVICE_LINK, RuleName: "payload.ruleName" },
  reboot_command_issued: { ...DEVICE_LINK, RebootSource: "payload.rebootSource" },
  scheduled_reboot_succeeded: DEVICE_LINK,
  scheduled_reboot_failed_offline: { ...DEVICE_LINK, RuleName: "payload.ruleName" },
  ap_radio_power_changed: { ...DEVICE_LINK, RadioBand: "payload.band", OldTxPower: "payload.oldTxPower", NewTxPower: "payload.newTxPower" },
  unexpected_router_reboot_detected: DEVICE_LINK,
  ap_mgmt_link_reestablished: DEVICE_LINK,
  sw_mgmt_link_reestablished: DEVICE_LINK,
  router_mgmt_link_reestablished: DEVICE_LINK,
};

export const EVENTS_LOG_MAP = {
  // System Audit
  device_synced: { DeviceNameWithMACAsLink: "deviceName" },
  device_sync_failed: { DeviceNameWithMACAsLink: "deviceName" },
  unexpected_ap_reboot_detected: { DeviceNameWithMACAsLink: "deviceName" },
  unexpected_sw_reboot_detected: { DeviceNameWithMACAsLink: "deviceName" },
  device_fw_upgrade_schedule_create: {
    ModelName: "payload.modelName",
    NewUpgradeWindow: "payload.upgradeWindow"
  },
  device_fw_upgrade_schedule_cancel: { ModelName: "payload.modelName" },
  device_fw_upgrade_schedule_change: {
    ModelName: "payload.modelName",
    OldVersion: "payload.oldVersion",
    NewVersion: "payload.newVersion",
    NewUpgradeWindow: "payload.upgradeWindow"
  },
  invite_user_org: {
    ChangedAccountNameWithUniqueLink: "payload.changedAccountName",
    Org: "orgName",
    AccountNameWithUniqueLink: "accountName"
  },
  invite_user_site: {
    ChangedAccountNameWithUniqueLink: "payload.changedAccountName",
    Site: "siteName",
    Org: "orgName",
    AccountNameWithUniqueLink: "accountName"
  },
  remove_user_org: {
    ChangedAccountName: "payload.changedAccountName",
    Org: "orgName",
    AccountNameWithUniqueLink: "accountName"
  },
  remove_user_site: {
    ChangedAccountName: "payload.changedAccountName",
    Org: "orgName",
    Site: "siteName",
    AccountNameWithUniqueLink: "accountName"
  },
  user_leave_org: {
    ChangedAccountName: "payload.changedAccountName",
    Site: "siteName",
    Org: "orgName",
  },
  user_leave_site: {
    ChangedAccountName: "payload.changedAccountName",
    Org: "orgName",
  },
  change_user_privilege: {
    ChangedAccountNameWithUniqueLink: "payload.changedAccountName",
    AccountNameWithUniqueLink: "accountName"
  },
  captive_portal_created: {
    PortalName: "payload.name",
    AccountNameWithUniqueLink: "accountName"
  },
  captive_portal_changed: {
    PortalName: "payload.name",
    AccountNameWithUniqueLink: "accountName"
  },
  captive_portal_delete: {
    PortalName: "payload.name",
    AccountNameWithUniqueLink: "accountName"
  },
  ip_address_profile_created: {
    IPAddressProfileName: "payload.name",
    AccountNameWithUniqueLink: "accountName"
  },
  ip_address_profile_deleted: {
    IPAddressProfileName: "payload.name",
    AccountNameWithUniqueLink: "accountName"
  },
  ip_address_profile_changed: {
    IPAddressProfileName: "payload.name",
    AccountNameWithUniqueLink: "accountName"
  },
  schedule_profile_created: {
    ScheduleProfileName: "payload.name",
    AccountNameWithUniqueLink: "accountName"
  },
  schedule_profile_deleted: {
    ScheduleProfileName: "payload.name",
    AccountNameWithUniqueLink: "accountName"
  },
  schedule_profile_changed: {
    ScheduleProfileName: "payload.name",
    AccountNameWithUniqueLink: "accountName"
  },
  ldap_server_created: {
    LdapServerName: "payload.name",
    AccountNameWithUniqueLink: "accountName"
  },
  ldap_server_changed: {
    LdapServerName: "payload.name",
    AccountNameWithUniqueLink: "accountName"
  },
  ldap_server_deleted: {
    LdapServerName: "payload.name",
    AccountNameWithUniqueLink: "accountName"
  },
  user_account_created: {
    UserAccountName: "payload.name",
    AccountNameWithUniqueLink: "accountName"
  },
  user_account_changed: {
    UserAccountName: "payload.name",
    AccountNameWithUniqueLink: "accountName"
  },
  user_account_deleted: {
    UserAccountName: "payload.name",
    AccountNameWithUniqueLink: "accountName"
  },
  device_account_changed: {
    AccountNameWithUniqueLink: "accountName"
  },
  device_adopt: {
    DeviceNameWithMACAsLink: "deviceName",
    AccountNameWithUniqueLink: "accountName"
  },
  device_removed: {
    DeviceName: "deviceName",
    AccountNameWithUniqueLink: "accountName"
  },
  device_moved: {
    DeviceNameWithMACAsLink: "deviceName",
    OldSite: "siteName",
    NewSite: "payload.newSiteName",
    AccountNameWithUniqueLink: "accountName"
  },
  wireless_created: {
    WirelessNetworkName: "payload.networkName",
    AccountNameWithUniqueLink: "accountName"
  },
  wireless_deleted: {
    WirelessNetworkName: "payload.networkName",
    AccountNameWithUniqueLink: "accountName"
  },
  wireless_changed: {
    WirelessNetworkName: "payload.networkName",
    AccountNameWithUniqueLink: "accountName"
  },
  device_radio_changed: {
    DeviceNameWithMACAsLink: "deviceName",
    AccountNameWithUniqueLink: "accountName"
  },
  device_network_changed: {
    DeviceNameWithMACAsLink: "deviceName",
    AccountNameWithUniqueLink: "accountName"
  },
  org_time_zone_changed: { AccountNameWithUniqueLink: "accountName" },
  site_time_zone_changed: {
    Site: "siteName",
    AccountNameWithUniqueLink: "accountName"
  },
  wireless_radio_changed: {
    Site: "siteName",
    AccountNameWithUniqueLink: "accountName"
  },
  wired_basic_changed: {
    Site: "siteName",
    AccountNameWithUniqueLink: "accountName"
  },
  wired_voice_vlan_changed: {
    Site: "siteName",
    AccountNameWithUniqueLink: "accountName"
  },
  wired_qos_changed: {
    Site: "siteName",
    AccountNameWithUniqueLink: "accountName"
  },
  wired_ipv4_acl_changed: {
    Site: "siteName",
    AccountNameWithUniqueLink: "accountName"
  },
  device_info_changed: {
    DeviceNameWithMACAsLink: "deviceName",
    OldDeviceInfo: "payload.oldData",
    NewDeviceInfo: "payload.newData",
    AccountNameWithUniqueLink: "accountName"
  },
  wired_port_changed: {
    DeviceNameWithMACAsLink: "deviceName",
    OldWiredSettings: "payload.oldData",
    NewWiredSettings: "payload.newData",
    AccountNameWithUniqueLink: "accountName"
  },
  port_profile_changed: {
    OldPortProfile: "payload.oldData",
    NewPortProfile: "payload.newData",
    AccountNameWithUniqueLink: "accountName"
  },
  duplicated_device_connection: {
    RejectDeviceId: "payload.rejectDeviceId",
    DeviceNameWithMACAsLink: "deviceName",
    RejectDeviceIp: "payload.rejectDeviceIp",
    OldDeviceId: "payload.oldDeviceId",
    OldDeviceIp: "payload.oldDeviceIp",
  },
  // ap
  // device 上線, 由 sentry 通知
  ap_online: { DeviceNameWithMACAsLink: "deviceName" },
  // device 斷線, 由 sentry 通知
  ap_offline: { DeviceNameWithMACAsLink: "deviceName" },
  // device 完成註冊, 由 sentry 通知
  ap_adopt: { DeviceNameWithMACAsLink: "deviceName" },
  // Device開始執行fw upgrade(下載fw, 寫進flash...)
  ap_firmware_progress: { DeviceNameWithMACAsLink: "deviceName" },
  // Device 完成 fw upgrade 
  ap_firmware_success: {
    DeviceNameWithMACAsLink: "deviceName",
    FWver: "payload.version"
  },
  // Device fw upgrade 失敗
  ap_firmware_fail: { DeviceNameWithMACAsLink: "deviceName" },
  // wifi client 成功連上 wifi 後, 通過 CP 驗證
  ap_client_auth_pass: {
    ClientNameWithMACAsLink: "payload.macAddress",
    DeviceNameWithMACAsLink: "deviceName",
    Username: "payload.username",
    "Client Manufacturer name": "payload.manufacturer",
    "reasonCode": "payload.reasonCode",
  },
  // wifi client 成功連上 wifi 後, 要進行 CP 驗證的時候失敗
  ap_client_auth_fail: {
    ClientNameWithMACAsLink: "payload.macAddress",
    DeviceNameWithMACAsLink: "deviceName",
    Username: "payload.username",
    "Client Manufacturer name": "payload.manufacturer",
    "reasonCode": "payload.reasonCode"
  },
  //  wifi client 成功連上wifi
  ap_client_joined: {
    ClientNameWithMACAsLink: "payload.macAddress",
    DeviceNameWithMACAsLink: "deviceName",
    ClientIpAddress: "payload.ipAddress",
    "Client Manufacturer name": "payload.manufacturer",
    "reasonCode": "payload.reasonCode"
  },
  // 
  ap_client_ip_changed: {
    ClientNameWithMACAsLink: "payload.macAddress",
    ClientIpAddress: "payload.ipAddress",
    "Client Manufacturer name": "payload.manufacturer",
  },
  // wifi client 離開 wifi
  ap_client_left: {
    ClientNameWithMACAsLink: "payload.macAddress",
    DeviceNameWithMACAsLink: "deviceName",
    "Client Manufacturer name": "payload.manufacturer",
  },
  // device 的 ip 改變
  ap_ip_changed: {
    DeviceNameWithMACAsLink: "deviceName",
    DeviceIpAddress: "payload.ipAddress",
  },
  // ap 的 channel 改變
  ap_radio_changed: {
    DeviceNameWithMACAsLink: "deviceName",
    RadioBand: "payload.band",
    OldChannel: "payload.oldChannel",
    NewChannel: "payload.newChannel",
  },
  // switch
  // device 上線, 由 sentry 通知
  sw_online: { DeviceNameWithMACAsLink: "deviceName" },
  // device 斷線, 由 sentry 通知
  sw_offline: { DeviceNameWithMACAsLink: "deviceName" },
  // device 完成註冊, 由 sentry 通知
  sw_adopt: { DeviceNameWithMACAsLink: "deviceName" },
  // Device 開始執行 fw upgrade(下載fw, 寫進flash...)
  sw_firmware_progress: { DeviceNameWithMACAsLink: "deviceName" },
  // Device 完成 fw upgrade 
  sw_firmware_success: {
    DeviceNameWithMACAsLink: "deviceName",
    FWver: "payload.version"
  },
  // Device fw upgrade 失敗
  sw_firmware_fail: { DeviceNameWithMACAsLink: "deviceName" },
  // device 的 ip 改變
  sw_ip_changed: {
    DeviceNameWithMACAsLink: "deviceName",
    DeviceIpAddress: "payload.ipAddress"
  },
  // device port link up
  sw_port_linkup: {
    PortNum: "payload.portNum",
    DeviceNameWithMACAsLink: "deviceName"
  },
  // device port link down
  sw_port_linkdown: {
    PortNum: "payload.portNum",
    DeviceNameWithMACAsLink: "deviceName"
  },
  // device port error
  sw_port_error: {
    PortNum: "payload.portNum",
    DeviceNameWithMACAsLink: "deviceName",
    ErrorTypeString: "payload.errorType"
  },
  // device port error recover
  sw_port_error_recover: {
    PortNum: "payload.portNum",
    DeviceNameWithMACAsLink: "deviceName",
    ErrorTypeString: "payload.errorType"
  },
  // device 上線, 由 sentry 通知
  proxy_online: { DeviceNameWithMACAsLink: "deviceName" },
  // device 斷線, 由 sentry 通知
  proxy_offline: { DeviceNameWithMACAsLink: "deviceName" },
  // proxy ssh connections
  proxy_ssh_auth_failed: {
    DeviceNameWithMACAsLink: "deviceName",
    PayloadDeviceNameWithMACAsLink: "payload.deviceId",
    "IP of connection destination": "payload.ip"
  },
  proxy_ssh_timeout: {
    DeviceNameWithMACAsLink: "deviceName",
    PayloadDeviceNameWithMACAsLink: "payload.deviceId",
    "IP of connection destination": "payload.ip"
  },
  proxy_ssh_reject: {
    DeviceNameWithMACAsLink: "deviceName",
    PayloadDeviceNameWithMACAsLink: "payload.deviceId",
    "IP of connection destination": "payload.ip"
  },
  proxy_ssh_failed: {
    DeviceNameWithMACAsLink: "deviceName",
    PayloadDeviceNameWithMACAsLink: "payload.deviceId",
    "IP of connection destination": "payload.ip"
  },
  // device ssh connections
  device_ssh_auth_fail: {
    ProxyName: "payload.proxyName",
    DeviceNameWithMACAsLink: "deviceName",
    "IP of connection destination": "payload.ip"
  },
  device_ssh_timeout: {
    ProxyName: "payload.proxyName",
    DeviceNameWithMACAsLink: "deviceName",
    "IP of connection destination": "payload.ip"
  },
  device_ssh_reject: {
    ProxyName: "payload.proxyName",
    DeviceNameWithMACAsLink: "deviceName",
    "IP of connection destination": "payload.ip"
  },
  device_ssh_failed: {
    ProxyName: "payload.proxyName",
    DeviceNameWithMACAsLink: "deviceName",
    "IP of connection destination": "payload.ip"
  },
  // router
  // device 上線, 由 sentry 通知
  router_online: { DeviceNameWithMACAsLink: "deviceName" },
  // device 斷線, 由 sentry 通知
  router_offline: { DeviceNameWithMACAsLink: "deviceName" },
  // device 完成註冊, 由 sentry 通知
  router_adopt: { DeviceNameWithMACAsLink: "deviceName" },
  // Device 開始執行 fw upgrade(下載fw, 寫進flash...)
  router_firmware_progress: { DeviceNameWithMACAsLink: "deviceName" },
  // Device 完成 fw upgrade 
  router_firmware_success: {
    DeviceNameWithMACAsLink: "deviceName",
    FWver: "payload.version"
  },
  // Device fw upgrade 失敗
  router_firmware_fail: { DeviceNameWithMACAsLink: "deviceName" },
  ...ADDITIONAL_EVENTS_LOG_MAP,
};
